// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__1Zpu7","input":"settings_input__1qSL6"};